<template>
	<v-form @submit.prevent="onSubmit">
		<slot></slot>
	</v-form>
</template>

<script>
export default {
	methods: {
		onSubmit(event) {
			this.$emit('submit', event)
		},
	},
}
</script>
